import React from 'react';
import classnames from 'classnames';

const LinkButton = ({ children, onClick, className, style, disabled, type = 'button' }) => {
  const classes = classnames('link-button', className);
  return (
    // eslint-disable-next-line react/button-has-type
    <button type={type} disabled={disabled} className={classes} style={style} onClick={onClick}>
      {children}
    </button>
  );
};

export default LinkButton;
